export default __webpack_public_path__ + "logo10d96edc.png";